/* eslint-disable no-undef */
import { CHAT_GPT_VALUES_ARRAY, LIVE_CHAT_COOKIE_KEY } from '../../common/constants/appConstant';
import { DEFAULT_ROOM_LISTING } from '../../common/constants/packageConstants';
import { getCookie } from '../../common/service/cookieService';
import { getAffiliate, getMMT_HLD_OBJ } from '../../common/utils/appUtils';
import {
  dateFormatter,
  formatURLDate,
  isMobile,
  isValidDate,
} from '../../common/utils/browserUtils';
import { getRoomFromParams } from '../../common/utils/formattingUtils';
import { getAllUrlParams, getAPWindow } from './utils';

export const propVarsToTrack = [
  'channel',
  'events',
  'eVar1',
  'eVar3',
  'eVar4',
  'eVar8',
  'eVar11',
  'eVar15',
  'eVar16',
  'eVar18',
  'eVar20',
  'eVar24',
  'eVar27',
  'eVar31',
  'eVar32',
  'eVar39',
  'eVar41',
  'eVar45',
  'eVar49',
  'eVar51',
  'eVar52',
  'eVar53',
  'eVar54',
  'eVar55',
  'eVar56',
  'eVar57',
  'eVar58',
  'eVar66',
  'eVar76',
  'eVar77',
  'eVar79',
  'eVar83',
  'eVar84',
  'eVar95',
  'eVar108',
  'prop1',
  'prop3',
  'prop4',
  'prop8',
  'prop11',
  'prop20',
  'prop23',
  'prop24',
  'prop27',
  'prop28',
  'prop36',
  'prop37',
  'prop38',
  'prop40',
  'prop41',
  'prop48',
  'prop51',
  'prop54',
  'prop56',
  'prop57',
  'prop70',
  'prop71',
  'prop72',
  'prop73',
  'prop74',
  'prop75',
];

const setCommonVars = ({ omniture, store, params }) => {
  const urlParams = getAllUrlParams();
  const dest = urlParams?.dest;
  const fromCity = urlParams?.depCity || 'New Delhi';
  const date = isValidDate(urlParams?.dateSearched)
    ? formatURLDate(urlParams?.dateSearched)
    : new Date();
  const travelDate = dateFormatter(date, 'MM/DD/YYYY') || '';
  const rooms = urlParams?.rooms ? getRoomFromParams(urlParams.rooms) : DEFAULT_ROOM_LISTING;
  const { groupMetadata, metadata, seo } = store?.getState() || {};
  const isListingView = !groupMetadata?.groupDetailsList?.length;
  const noOfAdults = rooms.reduce((sum, room) => room.noOfAdults + sum, 0);
  const noOfChildren = rooms.reduce(
    (sum, room) => room.noOfChildrenWB + room.noOfChildrenWOB + sum,
    0
  );
  const noOfInfants = rooms.reduce((sum, room) => room.noOfInfants + sum, 0);
  const branch =
    getMMT_HLD_OBJ()?.theme?.toLowerCase() === 'cruise'
      ? seo?.cruiseBranch || 'DOM'
      : metadata?.branch || 'DOM';
  const mcatFromAPI = metadata?.headerDetail?.destinationThemes?.join?.(',');
  omniture.prop3 = `${fromCity} | ${dest}`;
  if (isValidDate(urlParams?.dateSearched)) {
    omniture.prop4 = travelDate;
    omniture.prop8 = getAPWindow(date);
  }
  omniture.prop11 = `adults:${noOfAdults}_children:${noOfChildren}_infants:${noOfInfants}`;
  omniture.prop20 = `room_${rooms.length}`;
  omniture.eVar20 = `room_${rooms.length}`;
  omniture.pageName = getMMT_HLD_OBJ()?.fromSEO
    ? `seo: in ${branch.toLowerCase() === 'dom' ? 'domestic' : 'outbound'} holidays:packages ${
        urlParams?.themes === 'Cruise' ? 'cruises' : ''
      }`
    : `funnel:in ${branch.toLowerCase() === 'dom' ? 'domestic' : 'outbound'} holidays:listing`;
  omniture.eVar15 = `funnel:in ${
    branch.toLowerCase() === 'dom' ? 'domestic' : 'outbound'
  } holidays:listing`;
  omniture.channel = getMMT_HLD_OBJ()?.fromSEO
    ? `seotemplate in ${branch.toLowerCase()} holidays funnel`
    : `IN ${branch.toLowerCase()} holidays funnel`;
  omniture.Channel = getMMT_HLD_OBJ()?.fromSEO
    ? `seotemplate in ${branch.toLowerCase()} holidays funnel`
    : `IN ${branch.toLowerCase()} holidays funnel`;
  omniture.prop24 = `in ${branch.toLowerCase() === 'dom' ? 'domestic' : 'outbound'} holidays`;
  omniture.eVar24 = `in ${branch.toLowerCase() === 'dom' ? 'domestic' : 'outbound'} holidays`;
  omniture.eVar101 = isMobile() ? 'raw_mobile' : 'desktop';
  omniture.eVar31 = dest;
  omniture.eVar32 = fromCity;
  omniture.prop72 = `funnel:in ${
    branch.toLowerCase() === 'dom' ? 'domestic' : 'outbound'
  } holidays:listing`;
  omniture.eVar79 = decodeURIComponent(getCookie('AllocationTracking'));
  omniture.eVar108 = `holidays|${getMMT_HLD_OBJ()?.fromSEO ? 'SEO_' : ''}${
    isListingView ? 'listing' : 'collection'
  }:v3|${getAffiliate()}`;

  let themes = '';
  let mcatValue = '';
  if (urlParams.mcat) {
    themes = urlParams.mcat;
  }

  if (themes && mcatFromAPI) {
    mcatValue = [themes, mcatFromAPI].join(',');
  } else if (themes) {
    mcatValue = themes;
  } else if (mcatFromAPI) {
    mcatValue = mcatFromAPI;
  }

  omniture.eVar49 = mcatValue ? `mcat:${mcatValue}` : '';

  let source = '';
  if (urlParams.source) {
    source = urlParams.source;
  }
  const chatGPT = getCookie(LIVE_CHAT_COOKIE_KEY);
  if (chatGPT) {
    const chatGPTString = CHAT_GPT_VALUES_ARRAY[+chatGPT - 1];
    source = `${source || ''}${source ? ',' : ''}${chatGPTString}`;
  }

  if (source) {
    omniture.eVar108 = `${omniture.eVar108 || ''}${omniture.eVar108 ? '|' : ''}${source}`;
  }
};

export const setLoadVars = ({ omniture, store, params }) => {
  setCommonVars({ omniture, store, params });

  if (params?.eVar22) {
    omniture.eVar22 = params.eVar22;
  } else {
    omniture.eVar22 = '';
  }
  if (params?.eVar28) {
    omniture.eVar28 = params.eVar28;
  }
  if (params?.eVar31) {
    omniture.eVar31 = params.eVar31;
  }
  if (params?.eVar32) {
    omniture.eVar32 = params.eVar32;
  }
  // if (params?.eVar34) {
  //   omniture.eVar34 = params.eVar34;
  // }
  // if (params?.eVar35) {
  //   omniture.eVar35 = params.eVar35;
  // }
  if (params?.eVar77) {
    omniture.eVar77 = params.eVar77;
  }
  if (params?.eVar76) {
    omniture.eVar76 = params.eVar76;
  }
  if (params?.eVar108) {
    omniture.eVar108 = params.eVar108;
  }
  if (params?.prop48) {
    omniture.prop48 = params.prop48;
  } else {
    omniture.prop48 = '';
  }
  if (params?.prop54) {
    omniture.prop54 = params.prop54;
  }
  if (params?.prop1) {
    omniture.prop1 = params.prop1;
  }
  if (params?.prop70) {
    omniture.prop70 = params.prop70;
  }
  if (params?.events) {
    omniture.events = params.events;
    omniture.linkTrackEvents = params.events;
  } else {
    omniture.events = '';
    omniture.linkTrackEvents = '';
  }
  if (ssr.isOnClient && getMMT_HLD_OBJ()?.fromSEO) {
    omniture.prop1 = window.location.pathname.split('/')[2]?.split('.html')[0];
  }
};
export const setClickVars = ({ omniture, params, store }) => {
  setCommonVars({ omniture, store, params });
  if (params?.eVar49) {
    omniture.eVar49 = params.eVar49;
  }
  if (params?.eVar77) {
    omniture.eVar77 = params.eVar77;
  }
  if (params?.prop1) {
    omniture.prop1 = params?.prop1;
  }
  if (params?.prop54) {
    omniture.prop54 = params?.prop54;
  }
  if (params?.eVar108) {
    omniture.eVar108 = params?.eVar108;
  }
  if (params?.eVar76) {
    omniture.eVar76 = params?.eVar76;
  }
  if (params?.prop48) {
    omniture.prop48 = params.prop48;
  } else {
    omniture.prop48 = '';
  }

  if (params?.events) {
    omniture.events = params.events;
    omniture.linkTrackEvents = params.events;
  } else {
    omniture.events = '';
    omniture.linkTrackEvents = '';
  }
  if (ssr.isOnClient && getMMT_HLD_OBJ()?.fromSEO) {
    if (params?.prop1) {
      omniture.prop1 = `${params?.prop1}`;
    } else {
      omniture.prop1 = window.location.pathname.split('/')[2]?.split('.html')[0];
    }
  }
};
